import React from 'react';
import { useTranslation } from 'react-i18next';

import { redirectToUserData } from '../../../api/authService';
import useCurrentLanguage from 'utils/hooks/useCurrentLanguage';
import useMedia from 'utils/hooks/useMedia';

import useUserDetails from 'utils/hooks/auth/useUserDetails';

import Navbar from 'react-bulma-components/lib/components/navbar';
import './style.scss';
import { useDispatch } from 'react-redux';
import { logUserOutThunk } from '../../../store/entities/auth/thunks';
import useUserHasFullAuth from '../../../utils/hooks/auth/useUserHasFullAuth';

const NavPrimary = () => {
  const isAuthenticated = useUserHasFullAuth();
  const { t, i18n } = useTranslation();
  const language = useCurrentLanguage();
  const isMobile = useMedia(
      ['(max-width: 1023px)', '(min-width: 1px)'],
      [true, false],
      false
  );
  const { userFirstName, userLastName, username } = useUserDetails();
  const dispatch = useDispatch();

  return (
      <Navbar className="navbar__primary" color="primary">
        <Navbar.Menu>
          <Navbar.Container className="primary-navbar-container">
            <div className="navbar-meta-navigation">
              <stat-ee-header-apps
                  data-app="portaal"
                  data-lang={language || 'et'}
              />
            </div>
            <div className="social-btns">
              <stat-ee-header-social
                  data-app="portaal"
                  data-lang={language || 'et'}
                  data-style="dark"
              />
            </div>
            <div className="flex-center-y">
              <Navbar.Item dropdown hoverable href="#">
                <Navbar.Link>{language.toUpperCase()}</Navbar.Link>
                <Navbar.Dropdown>
                  <Navbar.Item onClick={() => i18n.changeLanguage('et')}>
                    ET
                  </Navbar.Item>
                  <Navbar.Item onClick={() => i18n.changeLanguage('en')}>
                    ENG
                  </Navbar.Item>
                </Navbar.Dropdown>
              </Navbar.Item>
              {!isMobile && isAuthenticated && (
                  <Navbar.Item dropdown hoverable href="#">
                    <Navbar.Link>
                      {userFirstName ? `${userFirstName} ${userLastName}` : username}
                    </Navbar.Link>
                    <Navbar.Dropdown right>
                      <Navbar.Item onClick={() => redirectToUserData(language)}>
                        {t('datagate.external.global.user.profile')}
                      </Navbar.Item>
                      <Navbar.Item onClick={() => dispatch(logUserOutThunk())}>
                        {t('datagate.external.global.logOut')}
                      </Navbar.Item>
                    </Navbar.Dropdown>
                  </Navbar.Item>
              )}
            </div>
          </Navbar.Container>
        </Navbar.Menu>
      </Navbar>
  );
};

export default NavPrimary;
